// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
// import { ParallelTaskComponent } from 'pages/task/task-form/components/parallel-task/parallel-task.component';
import { ASSETS } from '../../../assets/assets';
import { NgTryForDirective } from '../../../directives/_old_directives/ng-try-for.directive';
import { waitingTimer } from '../../../helpers/_old_helpers/animate';
import { SortTablePipe } from '../../../pipes/sortTable.pipe';
import { BodyFeedbackComponent } from '../body-feedback/body-feedback.component';
import { ParallelTaskService } from '../dynamic-form/sub-modules/parallel-tasks/parallel-task.service';
import { EntityFieldsComponent } from '../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { ErrorOverlayClass } from '../error-overlay/error-overlay.directive';
import { CommentForumComponent } from '../fields/comment-forum/comment-forum.component';
import { DatePickerComponent } from '../fields/date-picker/date-picker.component';
import { DateTimePickerComponent } from '../fields/date-time-picker/date-time-picker.component';
import { FilesDownloadComponent } from '../fields/files-download/files-download.component';
import { FlagStatusComponent } from '../fields/flag-status/flag-status.component';
import { InputHiddenComponent } from '../fields/input-hidden/input-hidden.component';
import { InputReferenceComponent } from '../fields/input-reference/input-reference.component';
import { InputTextComponent } from '../fields/input-text/input-text.component';
import { SelectTreeCondensedComponent } from '../fields/select-tree-condensed/select-tree-condensed.component';
import { TableListComponent } from '../fields/table-list/table-list.component';
import { TextareaComponent } from '../fields/textarea/textarea.component';
import { TimePickerRefComponent } from '../fields/timepicker/timepicker.component';
import { ModalDirective, ModalInterfaceComunication } from '../modal-overlay/modal.directive';
import { PaginationComponent } from '../pagination/pagination.component';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../popup-feedback/popup-feedback.directive';
import { ClickTableOutsideDirective } from './table.directive';
import { TopSticky } from './table.model';

@Component({
  selector: 'lbca-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  imports: [
    NgTryForDirective,
    NgClass,
    NgStyle,
    BodyFeedbackComponent,
    FlagStatusComponent,
    SelectTreeCondensedComponent,
    InputHiddenComponent,
    InputReferenceComponent,
    InputTextComponent,
    DatePickerComponent,
    DateTimePickerComponent,
    IconComponent,
    TimePickerRefComponent,
    forwardRef(() => EntityFieldsComponent),
    NgTemplateOutlet,
    ClickTableOutsideDirective,
    TextareaComponent,
    forwardRef(() => TableListComponent),
    forwardRef(() => FilesDownloadComponent),
    CommentForumComponent,
    PaginationComponent,
    // forwardRef(() => ParallelTaskComponent),
    SortTablePipe,
  ],
})
export class TableComponent implements OnInit, AfterViewInit, OnChanges {
  private overlay = inject(Overlay);
  private parallelTaskService = inject(ParallelTaskService);
  readonly assets = inject(ASSETS);

  private timeOut: any = null;
  private popupFeedController = new PopupInterfaceCommunication();
  public isDisabled = false;
  public selectedLine = null;

  private modalController = new ModalInterfaceComunication();
  public isParallel: boolean = false;
  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @HostBinding('attr.lbcaControllerModal') lbcaModal = new ModalDirective(
    this.overlay,
    this.modalController
  );
  private errorPopup!: ErrorOverlayClass;
  public editParallel: boolean = false;

  @ViewChild('inputSearch', { static: true }) inputSearch!: ElementRef;

  private _table: any;

  @Input()
  set table(value) {
    this._table = value;
  }
  get table() {
    return this._table;
  }
  @Input() selectableMode: boolean = false;
  @Input() fixedTop!: TopSticky;
  @Input() lineCickable = true;
  @Input() isSearcheable = true;
  @Input() paginationType: 'next' | 'prev' | 'choose' = 'choose';
  @Input() set loading(value) {
    this.isLoading = value;
  }
  @Input() bodyLength = 0;
  public dataAttr: any = {};
  @Input('dataAttr') set data(data) {
    this.dataAttr = data;
  }

  @Input('editParallel')
  set setEditParallel(value: any) {
    this.editParallel = value;
  }

  @Input()
  set removeLine(line) {
    if (!line) return;
    this.lineRemove.push(line);
  }

  @Input() set disabled(disabled) {
    this.isDisabled = disabled;
  }

  public editConfiguration: any = {
    // saveUrl: 'googleOficioLetter',
    // saveUrl: '/artifacts/saveDraft',
    // type: 'letter-edit',
  };

  public isEdit: boolean = false;
  @Input('field') set fieldValues(field) {
    this.isEdit = field ? (field.isEditable ? field.isEditable : false) : false;
    if (this.isEdit) {
      this.editConfiguration.type = field.auxEntity.type;
      this.editConfiguration.saveUrl = field.auxEntity.saveUrl;
      this.editConfiguration.tableName = field.auxEntity.tableName;
      this.editConfiguration.templateId = field.auxEntity.templateId;
    }
  }

  public fieldsLabels: any = {};

  @Input() saveOnChange = false;

  @Input()
  set rightDeslocation(line) {
    if (!line) return;

    const check = this.goRight.some((check) => check.id == line.id);

    if (!check) {
      this.goRight.push(line);
    } else {
      this.goRight = this.goRight.filter((item) => item.id !== line.id);
    }
  }

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
    this.isParallel = this.cardInfo.isParallel;
  }

  @Output() order = new EventEmitter();
  @Output() clickLine = new EventEmitter();
  @Output() selectLine = new EventEmitter();
  @Output() changeValue = new EventEmitter();
  @Output('saveChanges') saveEmmiter = new EventEmitter();
  @Output() openContextMenu = new EventEmitter();
  @Output('selectedPage') selectedPageValueEmmiter = new EventEmitter<number>();

  @ViewChild('itemList', { static: false }) itemList!: ElementRef;
  @ViewChild('inputValue', { static: false }) inputValue!: ElementRef;
  @ViewChild('inputValueAsc', { static: false }) inputValueAsc!: ElementRef;
  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;

  @ViewChild('ParallelTaskTemplate') parallelTaskModal!: TemplateRef<any>;

  private typingTimer;
  public enabledSearch = false;
  public directionOrder: 'ASC' | 'DESC' = 'ASC';
  public orderBy!: string;

  public isSearchImage = false;
  public isLoaded = true;
  public isLoading = false;
  public firstSearchComplete = false;
  public editingMode: boolean = false;

  private total!: any;

  private goRight: any = [];
  private lineRemove: any = [];
  public initialData: any = {};

  constructor() {
    const overlay = this.overlay;
    const elementRef = inject(ElementRef);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
      0,
      0,
      'top',
      'end'
    );
  }

  public saveData(data): void {
    for (let index = 0; index < this.table.body.length; index++) {
      const id = this.table.body[index].id;
      if (id === data.id) {
        this.table.body[index] = { ...this.table.body[index], ...data };
      }
    }

    setTimeout(() => {
      this.editingMode = false;
    }, 250);
  }

  public editItem(lane, taskTypeEdit) {
    this.parallelTaskService.subjectShowModal.next({ taskType: taskTypeEdit, externalData: lane });
  }

  checkLineDeslocation(lane) {
    return this.goRight.some((check) => check.id == lane.id);
  }

  checkLineRemove(lane) {
    return this.lineRemove.some((check) => check.id == lane.id);
  }

  getPercents(col) {
    if (typeof col === 'string' && !!col.indexOf('px')) return col;

    const percent = col / this.total.weight;

    return `calc((100% - ${this.total?.px ?? 0}px) * ${percent})`;
  }

  copyToClipboard($event) {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText($event.target.offsetParent.innerText).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }

  ngOnInit() {
    this.fieldsLabels = this.assets.labels.components.fields;
    this.total = {
      weight: 0,
      px: 0,
    };
    this.table.columns.forEach((col) => {
      if (typeof col.col === 'number') {
        this.total.weight += col.col;
      }
      if (typeof col.col === 'string' && col.col.indexOf('px')) {
        this.total.px += parseInt(col.col);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bodyLength']) {
      if (changes['bodyLength'].currentValue > 3 && this.isSearcheable) this.enabledSearch = true;
      else this.enabledSearch = false;
    }
  }

  public modalngOnDestroy(): void {
    setTimeout(() => {
      this.editingMode = false;
    }, 250);
  }

  ngAfterViewInit() {
    const name = this.getDefaultOrder();
    if (!name) return;
    // this.orderTable(name, 'ASC');
    setTimeout(() => (this.orderBy = name), 20);
  }

  public clickTableLine(line) {
    if (this.lineCickable) {
      if (this.selectableMode) {
        if (this.selectedLine != line.trackerId) {
          this.selectLine.emit(line);
          this.selectedLine = line.trackerId;
        } else {
          this.selectLine.emit(null);
          this.selectedLine = null;
        }
      } else this.clickLine.emit(line);
    }
  }

  contextTableLine(event, id): void {
    if (this.lineCickable) {
      event.preventDefault();
      this.openContextMenu.emit({ event, data: id });
    }
  }

  // public orderTableEvent($event, name, value){
  //   $event.stopPropagation();
  //   this.orderTable(name, value);
  // }

  public orderTable(name, value) {
    let directionOrder;

    if (value.checked) directionOrder = 'DESC';
    else directionOrder = 'ASC';

    const orderReponse = {
      directionOrder,
      propertyOrder: name,
    };

    this.order.emit(orderReponse);
  }

  public getHeadCss(col) {
    return col?.cssHeader;
  }

  public stopPropagation($event) {
    $event.stopPropagation();
  }

  public openSearch(self, inputSearch) {
    if (self.checked) {
      inputSearch.focus();
    }
  }

  public clickEdit($event: MouseEvent, laneData): void {
    this.initialData = laneData;
    $event.stopPropagation();
    this.modalController.showModal(this.parallelTaskModal);
    this.editingMode = true;
  }

  public modalEventListener() {
    setTimeout(() => {
      this.editingMode = false;
    }, 250);
    this.modalController.closeModal();
  }

  private getDefaultOrder() {
    const defaultColumn = this.table.columns.find((col) => col.orderDefault === true);
    return defaultColumn ? defaultColumn.name : null;
  }

  private async sendSerach(value) {
    this.firstSearchComplete = true;
    this.isLoaded = false;
    await waitingTimer(500);
    this.isLoaded = true;

    this.order.emit({
      searchCriteria: value,
    });
  }

  public setValue($event, lane, entityKey, editable = false) {
    const obj = { value: $event, lane, entityKey, editable };

    if (this.timeOut) clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => this.changeValue.emit(obj), 1000);
  }

  public searchString(inputSearch) {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => this.sendSerach(inputSearch.value), 300);
  }

  selectedPage(event) {
    this.selectedPageValueEmmiter.emit(event);
  }

  orientation(value: 'next' | 'prev'): void {
    this.paginationType = value;
  }
}
